import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { BrowserQRCodeReader } from '@zxing/browser';

export default function LocationQrScanner({
  title = "Select the Scanner option",
  onSubmit,
  onCancel,
  submitText = "",
  cancelText = "Cancel",
  printer
}) {
  const [showScanner, setShowScanner] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const codeReaderRef = useRef(null);

  // Handle upload button click
  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Handle file upload (QR image)
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          const codeReader = new BrowserQRCodeReader();
          try {
            const result = await codeReader.decodeFromImageElement(img);
            console.log('Decoded QR Code:', result.getText());
            setQrCode(result.getText());
          } catch (err) {
            console.error('Error decoding QR Code:', err);
            alert('No QR code found in the uploaded image.');
          }
        };
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle scanner start/stop
  useEffect(() => {
    if (showScanner) {
      const codeReader = new BrowserQRCodeReader();
      codeReaderRef.current = codeReader;

      let stream;

      const startScanner = async () => {
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'environment' }
          });
          videoRef.current.srcObject = stream;

          codeReader.decodeFromVideoDevice(
            null,
            videoRef.current,
            (result, error) => {
              if (result) {
                console.log('QR Code:', result.getText());
                setQrCode(result.getText());
                setShowScanner(false);
              }
              if (error && !(error instanceof codeReader.NotFoundException)) {
                console.error(error);
              }
            }
          );
        } catch (err) {
          console.error('Camera error:', err);
        }
      };

      startScanner();

      return () => {
        codeReader.reset();
        if (stream) {
          stream.getTracks().forEach((track) => track.stop());
        }
      };
    } else {
      if (codeReaderRef.current) {
        codeReaderRef.current.reset();
      }
    }
  }, [showScanner]);

  return (
    <div className="full-container printer-container card">
      {
        printer.length ?
        <div class="peripheral-devices mt-4">
            <h5 class="font-lg bold dark-text">Peripheral Devices</h5>
            <div class="table-responsive">
                <table class="table ">
                    <thead>
                        <tr>
                            <th>Device Name</th>
                            <th>Device Status</th>
                            <th>Media status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            printer.length ? printer.map((item, i) =>
                            // printer.length ? printer.map((item, i) =>
                            // <tbody>
                                <tr>
                                    <td><span class="status-indicator offline"></span> {item.deviceId}</td>
                                    <td> {item.deviceStatus} </td>
                                    <td>{item.mediaStatus}</td>
                                    <td></td>
                                </tr>
                            // </tbody>
                            ) : <p> No printer found</p>
                        }
                    </tbody>
                </table>
            </div>

        </div> : null
      }
      <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "8px", marginBottom: "16px" }}>
        <h4>{title}</h4>
      </div>
      <div className="mt-3">
        {/* Open Camera Button */}
        <button className="btn-add btn btn-primary btn-animation d-flex px-6 SerachBtn" disabled onClick={() => setShowScanner(true)}>
          Open Camera & Scan QR Code
        </button>
        {/* Scanner Video */}
        {showScanner && (
          <div style={{ marginTop: "20px" }}>
            <video
              ref={videoRef}
              style={{ width: "100%" }}
              autoPlay
              muted
              playsInline
            />
            <button
              className="btn btn-secondary mt-2"
              onClick={() => setShowScanner(false)}
            >
              Cancel
            </button>
          </div>
        )}

        {/* Upload Fallback */}
        <div style={{ marginTop: "20px" }}>
          <button
            className="btn btn-secondary btn-add btn-animation d-flex px-6 SerachBtn"
            onClick={handleUploadClick}
            disabled
          >
            Upload QR Image (Fallback)
          </button>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
        {/* Show scanned QR */}
        {qrCode && (
          <p style={{ marginTop: "10px" }}>
            <strong>Scanned QR Code:</strong> {qrCode}
          </p>
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "10px" }}>
        <button className="btn btn-primary btn-add btn-animation d-flex SerachBtn" onClick={() => onSubmit(qrCode)}>
          {submitText}
        </button>
        <button className="btn btn-secondary btn-animation d-flex SerachBtn" onClick={onCancel}>
          {cancelText}
        </button>
      </div>
    </div>
  );
}
